// @flow

import type { RecordingState } from "./types";
import { initialState as triageState } from "./triage";

export const initialState: RecordingState = {
  requestsInProgress: 0,
  wizardState: [],
  defaultWizardStep: 2,
  callInteraction: null,
  submitCurrentStep: false,
  currentStepData: null,
  absence: null,
  employeeAbsenceRecording: {
    employee: {},
    absences: [],
    eapDetails: [],
    positions: [],
    shiftPatterns: [],

    canOpenAbsence: false,
    canCloseAbsence: false,
    canReopenAbsence: false,
    canUpdateAbsence: false,
    firstTimeCaller: false,
    goodShapeApp: { appEnabled: null, onboarded: null, email: null, userType: null },
  },
  reasonAndDuration: null,
  reasonAndDurationFormData: {},
  query: null,
  employeeSearch: {},
  shiftPatternAnswers: {
    positionsLoaded: false,
    isAccurate: null,
    selectedPatterns: null,
    selectedLoad: null,
    timeLost: [],
  },
  updateTimeLost: null,
  employeePositions: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  clientShiftPatterns: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  callbackQueues: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  modals: {
    nextCallback: {
      visible: false,
      callback: null,
    },
    incomingCall: {
      visible: false,
    },
    nurseTransfer: {
      visible: false,
    },
    nurseCallback: {
      visible: false,
    },
    absenceInteractions: { visible: false, absenceId: null },
    addEmployee: { visible: false },
    closeAbsenceModal: { visible: false },
  },
  schemas: {
    absenceLanding: null,
    reasonAndDuration: null,
    timeLost: null,
    nurseTransferOfferSchema: null,
    employee: null,
    interactionNotes: null,
  },
  absenceRecordingConfig: null,
  callbackScript: null,
  error: null,
  triage: triageState,
  interactionType: null,
  selectedAbsence: null,
  isEmployeeRecordSidebarExpanded: true,
  employeeRecordNotifications: [],
  isNewCreatedEmployee: false,
  dynamicQuestions: [],
  standardQuestions: [],
  closeAbsenceOverride: false,
  nurseTransferDecision: null,
  nurseTransfer: {
    loading: false,
    results: null,
    selected: null,
    response: null,
    assignmentError: false,
  },
  nurseTransferQueue: {
    data: [],
    error: false,
  },
  nurseTransferOffer: null,
  acceptedTransfer: null,
  acceptedCallback: null,
  client: null,
  settings: null,
  employee: null,
  employeeScripts: null,
  employeeReasonsScripts: [],
  willingToTriage: false,
  autoIdData: {},
  callPurpose: null,
  clientSettings: null,
  autoIdDataPrefilled: false,
  referrals: {
    list: [],
    isValid: false,
  },
  clientInformation: {
    list: [],
    sort: { orders: [] },
    pagination: null,
    totalElements: 0,
  },
  isAbsenceDetailsSubmitted: false,
  isAbsenceClosed: false,
  medicalTriageHistory: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  medicalTriageDetails: null,
  jobDuties: [],
  questionsAnswers: {
    standard: [],
    dynamic: [],
  },
};
